<template>
  <div>
    <div class="myHead">
      <el-breadcrumb style="margin-top:20px;margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager'}">全流程安全生产</el-breadcrumb-item>
        <el-breadcrumb-item>教育培训</el-breadcrumb-item>
        <el-breadcrumb-item>扫码考试记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
      <div class="content">
          <div style="display: flex;width: 100%;justify-content: space-between;">
              <div></div>
              <Input search enter-button placeholder=" 请输入姓名/手机/身份证/企业/试卷" v-model="fileNameOrTag" @on-search="getData(1)"
                     style="width: 300px"/>
          </div>
          <div style="margin-top: 10px;">
              <template>
                  <el-table size="small"
                          :data="tableData"
                          style="width: 100%;margin-top: 2%">
                      <el-table-column prop="name" label="姓名"></el-table-column>
                      <el-table-column prop="cellphone" label="手机号码"></el-table-column>
                      <el-table-column prop="idCard" label="身份证"></el-table-column>
                      <el-table-column prop="company" label="企业"></el-table-column>
                      <el-table-column prop="questionnaireVo.name" label="试卷名"></el-table-column>
                      <el-table-column prop="score" label="分数"></el-table-column>
                      <el-table-column prop="passStatus" label="是否通过">
                          <template slot-scope="scope">
                              <el-tag type="danger" size="mini" v-if="scope.row.passStatus == 0"> 不通过 </el-tag>
                              <el-tag type="info" size="mini" v-if="scope.row.passStatus == 1"> 通过 </el-tag>
                          </template>
                      </el-table-column>
                      <el-table-column prop="answerStatus" label="状态">
                          <template slot-scope="scope">
                              <el-tag type="danger" size="mini" v-if="scope.row.answerStatus == 0"> 未答题 </el-tag>
                              <el-tag type="info" size="mini" v-if="scope.row.answerStatus == 1"> 已答题 </el-tag>
                          </template>
                      </el-table-column>
                      <el-table-column prop="questionnaireVo.questionBankVos.length" label="题目数"></el-table-column>
                      <el-table-column prop="startTime" label="开始时间"></el-table-column>
                      <el-table-column prop="endTime" label="结束时间"></el-table-column>

                      <el-table-column label="操作" width="180">
                          <template slot-scope="scope">
                              <el-button type="danger" size="mini" @click.native.prevent="deleteData(scope.row.id)"><i class="fa fa-check" ></i> 删除 </el-button>
                          </template>
                      </el-table-column>
                  </el-table>

                  <div style="margin-top: 10px;text-align: right">
                    <Page :total="total" :page-size="pageSize"
                        @on-change="getData"/>
                  </div>
              </template>
          </div>
      </div>

  </div>
</template>

<script>
export default {
    data(){
        return {
            tableData: [],
            fileNameOrTag:'',
            pageSize:10,
            currentPage:1,
            form:{},
            total:0,
            pageTotal:0,
        };
    },
    methods:{
        add: function () {
            this.$router.push({
                path: "/processManager/addQuestion",
            });

        },
        deleteData: function (id) {
            this.componentsMoudel.httpRequest
                .getRequestHander("/scancodeexamrecord/delete/"+id)
                .openLoad()
                .startPost()
                .then((res) => {
                  if(this.tableData.length <= 1 && this.currentPage > 1) {
                    this.currentPage -= 1
                  }
                    this.getData(this.currentPage);
                    this.$message({
                        showClose: true,
                        message: "删除成功",
                        type: "success",
                    });
                });

        },
        getData(page){
          this.currentPage = page
            let param ={};
            param.limit = this.pageSize;
            param.curPage = page;
            param.name = this.fileNameOrTag;
            this.componentsMoudel.httpRequest
                .getRequestHander(this.componentsMoudel.getData("urls").getScancodeexamrecord)
                .openLoad()
                .startPost(param)
                .then((res) => {
                    this.tableData = res.body.data;

                    // this.currentPage = res.body.page;
                    this.total = res.body.cum;
                    this.pageTotal = res.body.pageTotal;
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },


    },
    mounted:function () {
        this.getData(1);
    } ,
    created() {

    }

};
</script>

<style scoped>
.myHead {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 60px;
}
</style>
